import { createContext, useContext, useEffect, useState } from "react";
import { DARK, LIGHT } from "../themes/themes";

// ThemeContext entrega a paleta atual (DARK ou LIGHT) e a função de toggle.
// A escolha é persistida em localStorage para sobreviver a reloads.

const STORAGE_KEY = "tecmovel.turismo.theme";

const ThemeCtx = createContext({
  isDark: true,
  C: DARK,
  toggle: () => {},
});

export function ThemeProvider({ children }) {
  const [isDark, setIsDark] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === "dark") return true;
      if (stored === "light") return false;
    } catch {
      /* ignore */
    }
    return true;
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, isDark ? "dark" : "light");
    } catch {
      /* ignore */
    }
  }, [isDark]);

  const value = {
    isDark,
    C: isDark ? DARK : LIGHT,
    toggle: () => setIsDark((v) => !v),
  };

  return <ThemeCtx.Provider value={value}>{children}</ThemeCtx.Provider>;
}

export function useTheme() {
  return useContext(ThemeCtx);
}
